import { useEffect, useState } from 'react';
import { get } from 'lodash';
import { Controller, useForm } from 'react-hook-form';
import InputField from '../../../Common/InputField';
import CheckboxField from '../../../Common/CheckboxField';
import { Grid, Button, IconButton } from '@mui/material';
import TicketCharter from '../../Ticket-Notes/TicketCharter';
import DateField from '../../../Common/DateField';
import { State, City } from 'country-state-city';
import PhoneInput from 'react-phone-number-input/react-hook-form-input';
import { subDepartmentOptions } from '../../../Fields/subDepartmentOptions.js';
import {
  isValidPhoneNumber,
  isPossiblePhoneNumber,
} from 'react-phone-number-input';
import {
  postRequest,
  putRequest,
  getRequest,
} from '../../interceptor/interceptor';
import FullScreenLoader from '../../Loader/FullScreenLoader';
import {
  UPDATE_TICKET,
  ADD_TICKET,
  REQ_ID,
  REFERRAL_DATA_BY_CONTACT,
  TTD_DATES,
  GET_MANDALS,
  ASSIGNED_TO,
  GET_VILLAGES,
  GET_CONSTITUENCIES,
  GET_DISTRICTS,
} from '../../../apiConst';
import { useLocation, useNavigate } from 'react-router';
import SelectDropdown from '../../../Common/SelectDropdown';
import {
  grievanceApplicantFields,
  referalFields,
  grievanceRequestFields,
  dataEntryGrievanceTicketFields,
  requestFields,
  approvalActionFields,
} from '../../../Fields/grievanceFields';
import {
  grievanceApplicantFieldsTelugu,
  referalFieldsTelugu,
  grievanceRequestFieldsTelugu,
  dataEntryGrievanceTicketFieldsTelugu,
  requestFieldsTelugu,
} from '../../../Fields/grievanceFieldsTelugu.js';
import CkEditorComponent from '../../../Common/CkEditor';
import moment from 'moment';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import BackButton from '../../../Common/BackButton.jsx';

const AddGms = () => {
  const { role, designation, firstName } = useSelector((state) => state.user);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const fields = [
    ...dataEntryGrievanceTicketFields,
    ...grievanceApplicantFields,

    ...grievanceRequestFields,
  ];
  const [id, setId] = useState(null);
  const [isDisabledTicket, setIsDisabledTicket] = useState(false);
  const [ticketNo, setTicketNo] = useState(
    location?.state?.data?.task?.ticketNo || null
  );
  const [isEdit, setIsEdit] = useState(null);
  const [requestDetails, setRequestDetails] = useState(false);
  const [contactDetails, setContactDetails] = useState(false);
  const [detailsKnown, setDetailsKnown] = useState(false);
  const [other, setOther] = useState('');
  const [qualification, setQualification] = useState('');
  const [currentLocation, setCurrentLocation] = useState('');
  const [requestedLocation, setRequestedLocation] = useState('');
  const [referral, setReferral] = useState(false);
  const [ticket, setTicket] = useState(null);
  const [disableAllFields, setDisableAllFields] = useState(false);
  const [ttdDatesApproved, setTtdDatesApproved] = useState([]);
  const [ttdDatesInProgress, setTtdDatesInProgress] = useState([]);
  const [minDate, setMinDate] = useState('');
  const [issueOpen, setIssueOpen] = useState(moment().format('YYYY-MM-DD'));
  const [targetResolution, setTargetResolution] = useState(
    moment().format('YYYY-MM-DD')
  );

  const [states, setStates] = useState([]);
  const [state, setState] = useState('');
  const [district, setDistrict] = useState('');
  const [constituency, setConstituency] = useState('');
  const [constituencies, setConstituencies] = useState('');
  const [mandal, setMandal] = useState('');
  const [mandals, setMandals] = useState([]);
  const [village, setVillage] = useState('');
  const [villages, setVillages] = useState([]);
  const [cities, setCities] = useState([]);
  const [refType, setRefType] = useState('');
  const [assignedTo, setAssignedTo] = useState([]);

  const [referralType, setRefferalType] = useState([
    { label: 'Self', value: 'self' },
    { label: 'TDP Cadre', value: 'tdpCadre' },
    { label: 'Janasena Cadre', value: 'janasenaCadre' },
    { label: 'BJP Cadre', value: 'bjpCadre' },
    { label: 'Other', value: 'other' },
  ]);
  const [referralMode, setRefferalMode] = useState([
    { label: 'Letter', value: 'letter' },
    { label: 'Phone Call', value: 'phoneCall' },
    { label: 'Text Message', value: 'textMessage' },
    { label: 'In Person', value: 'inPerson' },
  ]);

  const [priority, setPriority] = useState([
    { label: 'High', value: 'high' },
    { label: 'Low', value: 'low' },
    { label: 'Medium', value: 'medium' },
  ]);

  const [requestType, setRequestType] = useState('');
  const [requestMode, setRequestMode] = useState('');
  const [personalRequestType, setPersonalRequestType] = useState('');
  const [stateDepartment, setStateDepartment] = useState('');
  const [centralDepartment, setCentralDepartment] = useState('');
  const [ttdAvailableSlot, setTtdAvailableSlot] = useState('');
  const [medicalRequestType, setMedicalRequestType] = useState('');
  const [communityRequestDepartment, setCommunityRequestDepartment] =
    useState('');

  const [isTicketToggle, setIsTicketToggle] = useState(true); // State to toggle the accordion
  const [isApplicantToggle, setIsApplicantToggle] = useState(true); // State to toggle the accordion
  const [isRequestToggle, setIsRequestToggle] = useState(true); // State to toggle the accordion
  const [isRefferalToggle, setIsRefferalToggle] = useState(true); // State to toggle the accordion
  const [privateRequestType, setPrivateRequestType] = useState('');
  const [employmentRequestType, setEmploymentRequestType] = useState('');
  const [isAssignedToggle, setIsAssignedToggle] = useState(true);

  const ticketToggleAccordion = () => {
    setIsTicketToggle(!isTicketToggle);
    // setIsApplicantToggle(false);
    // setIsRequestToggle(false);
    // setIsRefferalToggle(false);
  };
  const applicantToggleAccordion = () => {
    setIsApplicantToggle(!isApplicantToggle);
    // setIsRequestToggle(false);
    // setIsRefferalToggle(false);
    // setIsTicketToggle(false);
  };
  const requestToggleAccordion = () => {
    setIsRequestToggle(!isRequestToggle);
    // setIsRefferalToggle(false);
    // setIsTicketToggle(false);
    // setIsApplicantToggle(false);
  };
  const refferalToggleAccordion = () => {
    setIsRefferalToggle(!isRefferalToggle);
    // setIsApplicantToggle(false);
    // setIsRequestToggle(false);
    // setIsTicketToggle(false);
  };

  const assignedToggleAccordion = () => {
    setIsAssignedToggle(!isAssignedToggle);
  };
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    getValues,
    control,
    formState: { errors },
  } = useForm({});

  const emailValidation = {
    validate: (value) => {
      if (!value) return true;
      const emails = value.split(/[\s,]+/);
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return (
        emails.every((email) => emailRegex.test(email)) ||
        'Please enter valid email addresses separated by commas or spaces'
      );
    },
  };

  useEffect(() => {
    if (location?.state?.isEdit || location?.state?.isView) {
      location?.state?.isEdit && setIsEdit(location?.state?.isEdit);
      const { task } = location?.state?.data;
      console.log('task', task);

      // Set form fields using setValue
      fields.map((field) => setValue(field.fieldName, task[field.fieldName]));
      setTicketNo(task.ticketNo);
      setReferral(task.referral);
      setRequestDetails(task.requestDetails);
      // miscellaneous
      setOther(task.miscellaneous);
      setVillage(task?.village);
      //requestType
      setRequestType(task?.requestType);
      setPrivateRequestType(task?.privateRequestType);
      // personalRequestType
      setPersonalRequestType(task?.personalRequestType);
      setEmploymentRequestType(task?.employmentRequestType);
      setStateDepartment(task.stateDepartment);
      setCentralDepartment(task.centralDepartment);
      setTtdAvailableSlot(task.ttdAvailableSlot);

      // medicalRequestType
      setMedicalRequestType(task.medicalRequest);

      // Set individual form fields
      setValue('state', task?.state);
      setValue('requestTitle', task?.requestTitle);
      setValue('district', task?.district);
      setValue('constituency', task?.constituency);
      setValue('mandal', task?.mandal);
      setValue('applicantMiscellaneous', task?.applicantMiscellaneous);
      setValue('issuePOC', task?.issuePOC);
      setValue('issueContact', task?.issueContact);
      setValue('issueDepartment', task?.issueDepartment);
      setValue('referralType', task?.referralType);
      setValue('referralContact', task?.referralContact);
      setValue('referralName', task?.referralName);
      setValue('referralDesignation', task?.referralDesignation);
      setValue('referralMode', task?.referralMode);
      setValue('requestDetails', task?.requestDetails);
      setValue('requestType', task?.requestType);
      setValue('privateRequestType', task?.privateRequestType);
      setValue('employmentRequestType', task?.employmentRequestType);
      setValue('medicalRequestType', task?.medicalRequestType);
      setValue('personalRequestType', task?.personalRequestType);
      //setValue('ttdAvailableSlot', task?.ttdAvailableSlot);
      setValue('miscellaneous', task?.miscellaneous);
      setValue('qualification', task?.qualification);
      setValue('currentLocation', task?.currentLocation);
      setValue('requestedLocation', task?.requestedLocation);
      setValue('contactDetails', task?.contactDetails);
      setValue('detailsKnown', task?.detailsKnown);
      setValue('contactName', task?.contactName);
      setValue('contactNumber', task?.contactNumber);
      setValue('contactDesignation', task?.contactDesignation);
      setValue('hospitalName', task?.hospitalName);
      setValue('typeOfIllness', task?.typeOfIllness);
      setValue('estimateAmount', task?.estimateAmount);
      setValue('cost', task?.cost);
      setValue('grant', task?.grant);
      setValue('stateDepartment', task?.stateDepartment);
      setValue('centralDepartment', task?.centralDepartment);
      setValue('requestMode', task?.requestMode);
      setValue('staffDesignation', task?.staffDesignation);
      setValue('subDepartment', task?.subDepartment);
      // if (location?.state?.isView) {
      //   setDisableAllFields(true); // Disable fields for view mode
      // }
    } else {
      // If neither edit nor view, generate unique ID or perform other logic
      getUniqueId();
      setValue('staffDesignation', designation);
      setValue('ticketCreatedBy', firstName);
    }
  }, []);

  useEffect(() => {
    if (ttdDatesInProgress.length === 0 && ttdDatesApproved.length === 0) {
      getExcludedDates();
    }
    fetchAssignedTo();
  }, []);

  useEffect(() => {
    let today = new Date();
    setMinDate(new Date(today.setDate(today.getDate() + 1)));
    const indiaStates = State.getStatesOfCountry('IN');
    setStates(indiaStates);
  }, []);

  useEffect(() => {
    if (location?.state?.isEdit && states.length > 0) {
      setValue('state', location?.state?.data?.task?.state);
      setState(location?.state?.data?.task?.state);
    }
  }, [states]);

  useEffect(() => {
    if (location?.state?.isEdit && cities.length > 0) {
      setValue('district', location?.state?.data?.task?.district);
      setDistrict(location?.state?.data?.task?.district);
    }
  }, [cities]);

  useEffect(() => {
    if (
      location?.state?.isEdit &&
      location?.state?.data?.task?.requestMode === 'state' &&
      requestMode.length === 0
    ) {
      setRequestMode(location?.state?.data?.task?.requestMode);
    } else if (
      location?.state?.isEdit &&
      location?.state?.data?.task?.requestMode === 'central' &&
      requestMode.length === 0
    ) {
      setRequestMode(location?.state?.data?.task?.requestMode);
    } else if (
      location?.state?.isEdit &&
      location?.state?.data?.task?.requestMode === 'private' &&
      requestMode.length === 0
    ) {
      setRequestMode(location?.state?.data?.task?.requestMode);
    }
  }, [requestMode]);

  useEffect(() => {
    if (location?.state?.isEdit && constituencies.length > 0) {
      setValue('constituency', location?.state?.data?.task?.constituency);
      setConstituency(location?.state?.data?.task?.constituency);
    }
  }, [constituencies]);

  useEffect(() => {
    if (location?.state?.isEdit && mandals.length > 0) {
      setValue('mandal', location?.state?.data?.task?.mandal);
      setMandal(location?.state?.data?.task?.mandal);
    }
  }, [mandals]);

  useEffect(() => {
    if (location?.state?.isEdit && villages.length > 0) {
      setValue('village', location?.state?.data?.task?.village);
    }
  }, [villages]);

  // useEffect(() => {
  //   const indiaCities = City.getCitiesOfState('IN', state);
  //   const sortedCities = indiaCities.sort((a, b) => {
  //     if (a.name === 'Srikakulam') return -1;
  //     if (b.name === 'Srikakulam') return 1;
  //     return a.name.localeCompare(b.name);
  //   });
  //   setCities(sortedCities);
  // }, [state]);

  useEffect(() => {
    getCities(state);
  }, [state]);

  useEffect(() => {
    getConstituencies(district);
  }, [district]);

  useEffect(() => {
    getMandals(constituency);
  }, [constituency]);

  useEffect(() => {
    getVillages(mandal);
  }, [mandal]);

  const onCancel = () => {
    if (role === 'Grievance-Data-Entry-Operator') {
      navigate('/gms', {});
    } else {
      navigate('/gms', {});
    }
  };

  const fetchAssignedTo = async () => {
    await getRequest(`${ASSIGNED_TO}`).then((res) => {
      if (res) {
        console.log('🚀 ~ awaitgetRequest ~ es:', res);
        const options = [];
        res.forEach((item, index) => {
          options.push({
            label: item?.email,
            value: item?.email,
          });
        });
        setAssignedTo(options);
      }
    });
  };

  const getCities = (selectedState) => {
    if (selectedState !== 'AP') {
      const indiaCities = City.getCitiesOfState('IN', selectedState);

      setCities(indiaCities);
    } else {
      getRequest(`${GET_DISTRICTS}${selectedState}`)
        .then((res) => {
          console.log('res', res);
          const { data } = res;
          console.log('🚀 ~ .then ~ data:', data);
          if (data) {
            const sortedCities = data.sort((a, b) => {
              if (a.name === 'Srikakulam') return -1;
              if (b.name === 'Srikakulam') return 1;
              return a.name.localeCompare(b.name);
            });
            setCities(sortedCities);
          }
        })
        .catch((e) => {
          console.log('error getting districts', e);
          setCities([]);
        });
    }
  };

  const getConstituencies = (dis) => {
    getRequest(`${GET_CONSTITUENCIES}${dis}`)
      .then((res) => {
        console.log('res', res);
        const { data } = res;
        console.log('🚀 ~ .then ~ data:', data);
        if (data) {
          setConstituencies(data);
        }
      })
      .catch((e) => {
        console.log('error getting constituencies', e);
      });
  };

  const getMandals = (consti) => {
    getRequest(`${GET_MANDALS}${consti}`)
      .then((res) => {
        console.log('res', res);
        const { data } = res;
        console.log('🚀 ~ .then ~ data:', data);
        if (data) {
          setMandals(data);
        }
      })
      .catch((e) => {
        console.log('error getting mandals', e);
      });
  };

  const getVillages = (man) => {
    getRequest(`${GET_VILLAGES}${man}`)
      .then((res) => {
        console.log('res', res);
        const { data } = res;
        if (data) {
          setVillages(data);
        }
      })
      .catch((e) => {
        console.log('error getting mandals', e);
      });
  };

  const getUniqueId = () => {
    setIsLoading(true);
    getRequest(`${REQ_ID}`)
      .then((res) => {
        console.log('res', res);
        const { data } = res;
        if (data) {
          setValue('ticketNo', data);
          setTicketNo(data);
          setIsDisabledTicket(true);
          setIsLoading(false);
        } else {
          setIsLoading(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const getExcludedDates = () => {
    let url = '';
    url = getRequest(`${TTD_DATES}`);
    url
      .then((res) => {
        setTtdDatesApproved(res.approved);
        setTtdDatesInProgress(res.inprogress);
      })
      .catch((error) => {
        console.log('error ttd', error);
      });
  };

  const onSubmit = async (data, e) => {
    // console.log('e', e.target.value);
    // console.log('data', data);
    let ccEmails = [];

    if (data?.ccEmail) {
      ccEmails = data.ccEmail
        .split(/[\s,]+/) // split by comma or whitespace
        .map((email) => email.trim()) // trim whitespace
        .filter((email) => email.length > 0); // remove empty strings if any
    }

    // console.log("🚀 ~ onSubmit ~ ccEmails:", ccEmails)

    let url = '';
    setIsLoading(true);

    let phoneNumber = data?.applicantMobile;
    let referalNumber = data?.referralContact;

    if (referalNumber) {
      const isPhoneNumber = isValidPhoneNumber(phoneNumber);
      const isReferralContact = isValidPhoneNumber(referalNumber);
      if (!isPhoneNumber) {
        setIsLoading(false);
        return toast.error('Enter a valid applicant phone number!');
      } else if (!isReferralContact) {
        setIsLoading(false);
        return toast.error('Enter a valid referral phone number!');
      }

      // if (data?.assignedTo === '') {
      //   setIsLoading(false);
      //   return toast.error('Assigned to is required!');
      // }

      // if (data?.priority === '') {
      //   setIsLoading(false);
      //   return toast.error('Priority is required!');
      // }

      console.log('data?.assignedTo', data?.assignedTo);
      console.log('data?.priority', data?.priority);

      if (
        e.target.value === 'submit' &&
        data?.assignedTo !== '' &&
        data?.priority !== ''
      ) {
        data = {
          ...data,
          ccEmail: ccEmails,
          stateDepartment: stateDepartment,
          miscellaneous: other,
          privateRequestType: privateRequestType,
          personalRequestType: personalRequestType,
          medicalRequestType: medicalRequestType,
          qualification: qualification,
          currentLocation: currentLocation,
          requestedLocation: requestedLocation,
          contactDetails: contactDetails,
          detailsKnown: detailsKnown,
          centralDepartment: centralDepartment,
          assignedTo: data?.assignedTo,
          priority: data?.priority,
          // ttdAvailableSlot: moment(data.ttdAvailableSlot).format("YYYY-MM-DD"),
          targetResolution: moment(data.targetResolution).format('YYYY-MM-DD'),
          issueOpen: moment(data.issueOpen).format('YYYY-MM-DD'),
          ticketStatus: 'backlog',
          isStepperForm: false,
          isDraft: false,
        };

        let response;
        if (isEdit) {
          response = await putRequest(`${UPDATE_TICKET}`, data);
        } else {
          response = await postRequest(`${ADD_TICKET}`, data);
        }
        try {
          console.log('res', response);
          toast.success(response?.data?.message);
          setIsLoading(false);
          if (response?.data?.attachment?.url && response?.data?.ticketNo) {
            const pdfurl = response?.data?.attachment?.url;
            const link = document.createElement('a');
            link.href = pdfurl;
            link.setAttribute(
              'download',
              `${response?.data?.attachment?.url}.pdf`
            );
            document.body.appendChild(link);
            link.click();
          }
          if (
            role === 'Grievance-Data-Entry-Operator' &&
            response?.data?.message
          ) {
            setIsLoading(false);
            reset();
            getUniqueId();
          } else if (response?.data?.message) {
            setIsLoading(false);
            reset();
            getUniqueId();
          } else {
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
        }
      } else {
        data = {
          ...data,
          ccEmail: ccEmails,
          stateDepartment: stateDepartment,
          centralDepartment: centralDepartment,
          miscellaneous: other,
          privateRequestType: privateRequestType,
          personalRequestType: personalRequestType,
          medicalRequestType: medicalRequestType,
          assignedTo: data?.assignedTo,
          priority: data?.priority,
          //  ttdAvailableSlot: moment(data.ttdAvailableSlot).format("YYYY-MM-DD"),
          targetResolution: moment(data.targetResolution).format('YYYY-MM-DD'),
          issueOpen: moment(data.issueOpen).format('YYYY-MM-DD'),
          ticketStatus: 'backlog',
          isStepperForm: false,
          isDraft: true,
        };

        let response;
        if (isEdit) {
          response = await putRequest(`${UPDATE_TICKET}`, data);
        } else {
          response = await postRequest(`${ADD_TICKET}`, data);
        }
        try {
          console.log('res', response);
          toast.info(response?.data?.message);
          setIsLoading(false);
          // if (response?.data?.attachment?.url && response?.data?.ticketNo) {
          //   const pdfurl = response?.data?.attachment?.url;
          //   const link = document.createElement('a');
          //   link.href = pdfurl;
          //   link.setAttribute(
          //     'download',
          //     `${response?.data?.attachment?.url}.pdf`
          //   );
          //   document.body.appendChild(link);
          //   link.click();
          // }
          if (role === 'Grievance-Data-Entry-Operator') {
            reset();
            navigate('/gms', {});
          } else {
            reset();
            navigate('/gms', {});
          }
        } catch (error) {
          setIsLoading(false);
        }
      }
    } else {
      const isPhoneNumber = isValidPhoneNumber(phoneNumber);
      //const isReferralContact = isValidPhoneNumber(referalNumber);
      if (!isPhoneNumber) {
        setIsLoading(false);
        return toast.error('Enter a valid applicant phone number!');
      }

      if (e.target.value === 'submit') {
        data = {
          ...data,
          ccEmail: ccEmails,
          stateDepartment: stateDepartment,
          miscellaneous: other,
          privateRequestType: privateRequestType,
          personalRequestType: personalRequestType,
          medicalRequestType: medicalRequestType,
          qualification: qualification,
          currentLocation: currentLocation,
          requestedLocation: requestedLocation,
          contactDetails: contactDetails,
          detailsKnown: detailsKnown,
          centralDepartment: centralDepartment,
          // ttdAvailableSlot: moment(data.ttdAvailableSlot).format("YYYY-MM-DD"),
          targetResolution: moment(data.targetResolution).format('YYYY-MM-DD'),
          issueOpen: moment(data.issueOpen).format('YYYY-MM-DD'),
          ticketStatus: 'backlog',
          isStepperForm: false,
          isDraft: false,
        };

        let response;
        if (isEdit) {
          response = await putRequest(`${UPDATE_TICKET}`, data);
        } else {
          response = await postRequest(`${ADD_TICKET}`, data);
        }
        try {
          console.log('res', response);
          toast.info(response?.data?.message);
          setIsLoading(false);
          if (response?.data?.attachment?.url && response?.data?.ticketNo) {
            const pdfurl = response?.data?.attachment?.url;
            const link = document.createElement('a');
            link.href = pdfurl;
            link.setAttribute(
              'download',
              `${response?.data?.attachment?.url}.pdf`
            );
            document.body.appendChild(link);
            link.click();
          }
          if (
            role === 'Grievance-Data-Entry-Operator' &&
            response?.data?.message
          ) {
            setIsLoading(false);
            reset();
            getUniqueId();
          } else if (response?.data?.message) {
            setIsLoading(false);
            reset();
            getUniqueId();
          } else {
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
        }
      } else {
        data = {
          ...data,
          ccEmail: ccEmails,
          stateDepartment: stateDepartment,
          centralDepartment: centralDepartment,
          privateRequestType: privateRequestType,
          miscellaneous: other,
          personalRequestType: personalRequestType,
          medicalRequestType: medicalRequestType,
          //  ttdAvailableSlot: moment(data.ttdAvailableSlot).format("YYYY-MM-DD"),
          targetResolution: moment(data.targetResolution).format('YYYY-MM-DD'),
          issueOpen: moment(data.issueOpen).format('YYYY-MM-DD'),
          ticketStatus: 'new',
          isStepperForm: false,
          isDraft: true,
        };

        let response;
        if (isEdit) {
          response = await putRequest(`${UPDATE_TICKET}`, data);
        } else {
          response = await postRequest(`${ADD_TICKET}`, data);
        }
        try {
          console.log('res', response);
          toast.info(response?.data?.message);
          setIsLoading(false);
          // if (response?.data?.attachment?.url && response?.data?.ticketNo) {
          //   const pdfurl = response?.data?.attachment?.url;
          //   const link = document.createElement('a');
          //   link.href = pdfurl;
          //   link.setAttribute(
          //     'download',
          //     `${response?.data?.attachment?.url}.pdf`
          //   );
          //   document.body.appendChild(link);
          //   link.click();
          // }
          if (role === 'Grievance-Data-Entry-Operator') {
            reset();
            navigate('/gms', {});
          } else {
            reset();
            navigate('/gms', {});
          }
        } catch (error) {
          setIsLoading(false);
        }
      }
    }
  };

  const fetchReferralDetails = (contactNumber) => {
    setIsLoading(true);
    getRequest(`${REFERRAL_DATA_BY_CONTACT}${contactNumber}`)
      .then((res) => {
        if (res) {
          // Assuming the API response contains `referralName` and `referralDesignation`
          setValue('referralName', res.referralName || '');
          setValue('referralDesignation', res.referralDesignation || '');
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleBlur = (e) => {
    const contactNumber = '+91' + e.target.value.replace(/[^\d\+]/g, '');
    if (refType !== 'self' && contactNumber) {
      fetchReferralDetails(contactNumber);
    }
  };

  console.log('requestType', requestType);

  const conditionalFields = [
    {
      fieldName: 'personalRequestType',
      fieldTitle: 'Personal Request Type*',
      // validationObj: {
      //   required: 'Please Select Request Type',
      // },
      fieldType: 'select',
      options: [
        {
          label: 'Employment Request',
          value: 'Employment Request',
        },
        {
          label: 'Transfer Request',
          value: 'Transfer Request',
        },
        // {
        //   label: 'TTD Darshan',
        //   value: 'TTD Darshan',
        // },
        {
          label: 'Other',
          value: 'other',
        },
      ], // Populate with request type options
    },
    {
      fieldName: 'stateDepartment',
      fieldTitle: 'Department*',
      // validationObj: {
      //   required: 'Please Select Department',
      // },
      fieldType: 'select',
      options: [
        { label: 'Collectorate', value: 'Collectorate' },
        { label: 'Judiciary', value: 'Judiciary' },
        { label: 'Revenue', value: 'Revenue' },
        { label: 'Judiciary', value: 'Judiciary' },
        { label: 'Housing', value: 'Housing' },
        { label: 'Panchayat Raj', value: 'Panchayat Raj' },
        { label: 'Roads & Buildings', value: 'Roads & Buildings' },
        { label: 'Agriculture', value: 'Agriculture' },
        { label: 'Police', value: 'Police' },
        { label: 'Fisheries', value: 'Fisheries' },
        { label: 'Forest', value: 'Forest' },
        { label: 'Health', value: 'Health' },
        { label: 'Education', value: 'Education' },
        { label: 'Irrigation', value: 'Irrigation' },
        { label: 'Endowment', value: 'Endowment' },
        { label: 'Rural Water Supply', value: 'Rural Water Supply' },
        { label: 'Municipal Corporation', value: 'Municipal Corporation' },
        { label: 'Zilla Parishad', value: 'Zilla Parishad' },
        { label: 'Tribal Welfare', value: 'Tribal Welfare' },
        { label: 'DRDA', value: 'DRDA' },
        { label: 'DWMA', value: 'DWMA' },
        { label: 'Planning', value: 'Planning' },
        { label: 'Transport', value: 'Transport' },
        { label: 'Pollution Control Board', value: 'Pollution Control Board' },
        { label: 'Civil Supplies', value: 'Civil Supplies' },
        { label: 'Animal Husbandry', value: 'Animal Husbandry' },
        { label: 'Horticulture', value: 'Horticulture' },
        { label: 'Tourism', value: 'Tourism' },
        { label: 'Electrical', value: 'Electrical' },
        { label: 'Women and Child Welfare', value: 'Women and Child Welfare' },
        {
          label: 'Social Welfare (SC,ST,BC)',
          value: 'Social Welfare (SC,ST,BC)',
        },
        {
          label: 'Industry & Commerce Department',
          value: 'Industry & Commerce Department',
        },
        {
          label: 'Other',
          value: 'Other',
        },
      ],
      // Populate with request type options
    },

    {
      fieldName: 'medicalRequestType',
      fieldTitle: 'Medical Request Type*',
      // validationObj: {
      //   required: 'Please Select Request Type',
      // },
      fieldType: 'select',
      options: [
        {
          label: 'CMRF',
          value: 'CMRF',
        },
        {
          label: 'PMRF',
          value: 'PMRF',
        },
        {
          label: 'Medical Aid',
          value: 'Medical Aid',
        },
      ], // Populate with request type options
    },
    {
      fieldName: 'ttdAvailableSlot',
      fieldTitle: 'TTD Available Slot*',
      fieldType: 'date',
    },
    {
      fieldName: 'miscellaneous',
      fieldTitle: 'Miscellaneous*',
      fieldType: 'text',
    },
    {
      fieldName: 'qualification',
      fieldTitle: 'Qualification*',
      fieldType: 'text',
    },
    {
      fieldName: 'department',
      fieldTitle: 'Department*',
      fieldType: 'text',
    },
    {
      fieldName: 'currentLocation',
      fieldTitle: 'Current Location*',
      fieldType: 'text',
    },
    {
      fieldName: 'requestedLocation',
      fieldTitle: 'Requested Location*',
      fieldType: 'text',
    },
    {
      fieldName: 'centralDepartment',
      fieldTitle: 'Department*',
      // validationObj: {
      //   required: 'Please Select Department',
      // },
      fieldType: 'select',
      options: [
        {
          label: "Agriculture & Farmers' Welfare",
          value: "Agriculture & Farmers' Welfare",
        },
        {
          label: 'Animal Husbandry, Dairying & Fisheries',
          value: 'Animal Husbandry, Dairying & Fisheries',
        },
        { label: 'AYUSH', value: 'AYUSH' },
        { label: 'Chemicals & Fertilizers', value: 'Chemicals & Fertilizers' },
        { label: 'Civil Aviation', value: 'Civil Aviation' },
        { label: 'Coal', value: 'Coal' },
        { label: 'Commerce & Industry', value: 'Commerce & Industry' },
        { label: 'Communications', value: 'Communications' },
        {
          label: 'Consumer Affairs, Food & Public Distribution',
          value: 'Consumer Affairs, Food & Public Distribution',
        },
        { label: 'Co-operation', value: 'Co-operation' },
        { label: 'Corporate Affairs', value: 'Corporate Affairs' },
        { label: 'Culture', value: 'Culture' },
        { label: 'Defence', value: 'Defence' },
        {
          label: 'Development of North Eastern Region',
          value: 'Development of North Eastern Region',
        },
        { label: 'Earth Sciences', value: 'Earth Sciences' },
        { label: 'Education', value: 'Education' },
        {
          label: 'Electronics & Information Technology',
          value: 'Electronics & Information Technology',
        },
        {
          label: 'Environment, Forests & Climate Change',
          value: 'Environment, Forests & Climate Change',
        },
        { label: 'External Affairs', value: 'External Affairs' },
        { label: 'Finance', value: 'Finance' },
        {
          label: 'Food Processing Industries',
          value: 'Food Processing Industries',
        },
        { label: 'Health & Family Welfare', value: 'Health & Family Welfare' },
        { label: 'Heavy Industries', value: 'Heavy Industries' },
        { label: 'Home Affairs', value: 'Home Affairs' },
        { label: 'Housing & Urban Affairs', value: 'Housing & Urban Affairs' },
        {
          label: 'Information & Broadcasting',
          value: 'Information & Broadcasting',
        },
        { label: 'Jal Shakti', value: 'Jal Shakti' },
        { label: 'Labour & Employment', value: 'Labour & Employment' },
        { label: 'Law & Justice', value: 'Law & Justice' },
        {
          label: 'Micro, Small & Medium Enterprises',
          value: 'Micro, Small & Medium Enterprises',
        },
        { label: 'Mines', value: 'Mines' },
        { label: 'Minority Affairs', value: 'Minority Affairs' },
        { label: 'New & Renewable Energy', value: 'New & Renewable Energy' },
        { label: 'Panchayati Raj', value: 'Panchayati Raj' },
        { label: 'Parliamentary Affairs', value: 'Parliamentary Affairs' },
        {
          label: 'Personnel, Public Grievances & Pensions',
          value: 'Personnel, Public Grievances & Pensions',
        },
        { label: 'Petroleum & Natural Gas', value: 'Petroleum & Natural Gas' },
        { label: 'Planning', value: 'Planning' },
        {
          label: 'Ports, Shipping & Waterways',
          value: 'Ports, Shipping & Waterways',
        },
        { label: 'Power', value: 'Power' },
        { label: "Prime Minister's Office", value: "Prime Minister's Office" },
        { label: 'Rural Development', value: 'Rural Development' },
        {
          label: 'Road Transport & Highways',
          value: 'Road Transport & Highways',
        },
        { label: 'Railways', value: 'Railways' },
        { label: 'Science & Technology', value: 'Science & Technology' },
        {
          label: 'Skill Development & Entrepreneurship',
          value: 'Skill Development & Entrepreneurship',
        },
        {
          label: 'Social Justice & Empowerment',
          value: 'Social Justice & Empowerment',
        },
        {
          label: 'Statistics & Programme Implementation',
          value: 'Statistics & Programme Implementation',
        },
        { label: 'Steel', value: 'Steel' },
        { label: 'Textiles', value: 'Textiles' },
        { label: 'Tourism', value: 'Tourism' },
        { label: 'Tribal Affairs', value: 'Tribal Affairs' },
        {
          label: 'Women & Child Development',
          value: 'Women & Child Development',
        },
        { label: 'Youth Affairs & Sports', value: 'Youth Affairs & Sports' },
        {
          label: 'Other',
          value: 'Other',
        },
      ], // Populate with request type options
    },
    {
      fieldName: 'contactDetails',
      fieldTitle: 'Contact Details',
      fieldType: 'checkbox', // This seems like a checkbox based on the image
    },
    {
      fieldName: 'detailsKnown',
      fieldTitle: 'Details Known',
      fieldType: 'checkbox', // This seems like a checkbox based on the image
    },
    {
      fieldName: 'subDepartment',
      fieldTitle: 'Sub Department',
      fieldType: 'select',
      options: subDepartmentOptions,
    },
    {
      fieldName: 'requestType',
      fieldTitle: 'Request Type*',
      fieldType: 'select',
      options: [
        { label: 'Personal', value: 'personal' },
        { label: 'Community', value: 'community' },
        { label: 'Official', value: 'official' },
        { label: 'Medical', value: 'medical' },
        { label: 'Other', value: 'other' },
      ],
    },
    {
      fieldName: 'privateRequestType',
      fieldTitle: 'Request Type*',
      fieldType: 'select',
      options: [
        {
          label: 'Employment',
          value: 'Employment',
        },
        {
          label: 'Help/Assistance',
          value: 'Help/Assistance',
        },
        {
          label: 'Other',
          value: 'other',
        },
      ],
    },
    {
      fieldName: 'employmentRequestType',
      fieldTitle: 'Employment Request Type*',
      fieldType: 'select',
      options: [
        {
          label: 'New Job',
          value: 'New Job',
        },
        {
          label: 'Role Change',
          value: 'Role Change',
        },
        {
          label: 'Transfer',
          value: 'Transfer',
        },
        {
          label: 'Other',
          value: 'other',
        },
      ],
    },
  ];

  const conditionalFieldsTelugu = [
    {
      fieldName: 'personalRequestType',
      fieldTitle: 'వ్యక్తిగత అభ్యర్థన రకం*',
      // validationObj: {
      //   required: 'Please Select Request Type',
      // },
      fieldType: 'select',
      options: [
        {
          label: 'Employment Request',
          value: 'Employment Request',
        },
        {
          label: 'Transfer Request',
          value: 'Transfer Request',
        },
        // {
        //   label: 'TTD Darshan',
        //   value: 'TTD Darshan',
        // },
        {
          label: 'Other',
          value: 'other',
        },
      ], // Populate with request type options
    },
    {
      fieldName: 'stateDepartment',
      fieldTitle: 'శాఖ*',
      // validationObj: {
      //   required: 'Please Select Department',
      // },
      fieldType: 'select',
      options: [
        { label: 'Collectorate', value: 'Collectorate' },
        { label: 'Judiciary', value: 'Judiciary' },
        { label: 'Revenue', value: 'Revenue' },
        { label: 'Judiciary', value: 'Judiciary' },
        { label: 'Housing', value: 'Housing' },
        { label: 'Panchayat Raj', value: 'Panchayat Raj' },
        { label: 'Roads & Buildings', value: 'Roads & Buildings' },
        { label: 'Agriculture', value: 'Agriculture' },
        { label: 'Police', value: 'Police' },
        { label: 'Fisheries', value: 'Fisheries' },
        { label: 'Forest', value: 'Forest' },
        { label: 'Health', value: 'Health' },
        { label: 'Education', value: 'Education' },
        { label: 'Irrigation', value: 'Irrigation' },
        { label: 'Endowment', value: 'Endowment' },
        { label: 'Rural Water Supply', value: 'Rural Water Supply' },
        { label: 'Municipal Corporation', value: 'Municipal Corporation' },
        { label: 'Zilla Parishad', value: 'Zilla Parishad' },
        { label: 'Tribal Welfare', value: 'Tribal Welfare' },
        { label: 'DRDA', value: 'DRDA' },
        { label: 'DWMA', value: 'DWMA' },
        { label: 'Planning', value: 'Planning' },
        { label: 'Transport', value: 'Transport' },
        { label: 'Pollution Control Board', value: 'Pollution Control Board' },
        { label: 'Civil Supplies', value: 'Civil Supplies' },
        { label: 'Animal Husbandry', value: 'Animal Husbandry' },
        { label: 'Horticulture', value: 'Horticulture' },
        { label: 'Tourism', value: 'Tourism' },
        { label: 'Electrical', value: 'Electrical' },
        { label: 'Women and Child Welfare', value: 'Women and Child Welfare' },
        {
          label: 'Social Welfare (SC,ST,BC)',
          value: 'Social Welfare (SC,ST,BC)',
        },
        {
          label: 'Industry & Commerce Department',
          value: 'Industry & Commerce Department',
        },
        {
          label: 'Other',
          value: 'Other',
        },
      ], // Populate with request type options
    },

    {
      fieldName: 'medicalRequestType',
      fieldTitle: 'వైద్య అభ్యర్థన రకం*',
      // validationObj: {
      //   required: 'Please Select Request Type',
      // },
      fieldType: 'select',
      options: [
        {
          label: 'CMRF',
          value: 'CMRF',
        },
        {
          label: 'PMRF',
          value: 'PMRF',
        },
        {
          label: 'Medical Aid',
          value: 'Medical Aid',
        },
      ], // Populate with request type options
    },
    {
      fieldName: 'ttdAvailableSlot',
      fieldTitle: 'టీటీడీ స్లాట్*',
      fieldType: 'date',
    },
    {
      fieldName: 'miscellaneous',
      fieldTitle: 'ఇతరాలు*',
      fieldType: 'text',
    },
    {
      fieldName: 'qualification',
      fieldTitle: 'అర్హత*',
      fieldType: 'text',
    },
    {
      fieldName: 'department',
      fieldTitle: 'శాఖ*',
      fieldType: 'text',
    },
    {
      fieldName: 'currentLocation',
      fieldTitle: 'ప్రస్తుత స్థానం*',
      fieldType: 'text',
    },
    {
      fieldName: 'requestedLocation',
      fieldTitle: 'అభ్యర్థించబడిన స్థానం*',
      fieldType: 'text',
    },
    {
      fieldName: 'centralDepartment',
      fieldTitle: 'శాఖ*',
      // validationObj: {
      //   required: 'Please Select Department',
      // },
      fieldType: 'select',
      options: [
        {
          label: "Agriculture & Farmers' Welfare",
          value: "Agriculture & Farmers' Welfare",
        },
        {
          label: 'Animal Husbandry, Dairying & Fisheries',
          value: 'Animal Husbandry, Dairying & Fisheries',
        },
        { label: 'AYUSH', value: 'AYUSH' },
        { label: 'Chemicals & Fertilizers', value: 'Chemicals & Fertilizers' },
        { label: 'Civil Aviation', value: 'Civil Aviation' },
        { label: 'Coal', value: 'Coal' },
        { label: 'Commerce & Industry', value: 'Commerce & Industry' },
        { label: 'Communications', value: 'Communications' },
        {
          label: 'Consumer Affairs, Food & Public Distribution',
          value: 'Consumer Affairs, Food & Public Distribution',
        },
        { label: 'Co-operation', value: 'Co-operation' },
        { label: 'Corporate Affairs', value: 'Corporate Affairs' },
        { label: 'Culture', value: 'Culture' },
        { label: 'Defence', value: 'Defence' },
        {
          label: 'Development of North Eastern Region',
          value: 'Development of North Eastern Region',
        },
        { label: 'Earth Sciences', value: 'Earth Sciences' },
        { label: 'Education', value: 'Education' },
        {
          label: 'Electronics & Information Technology',
          value: 'Electronics & Information Technology',
        },
        {
          label: 'Environment, Forests & Climate Change',
          value: 'Environment, Forests & Climate Change',
        },
        { label: 'External Affairs', value: 'External Affairs' },
        { label: 'Finance', value: 'Finance' },
        {
          label: 'Food Processing Industries',
          value: 'Food Processing Industries',
        },
        { label: 'Health & Family Welfare', value: 'Health & Family Welfare' },
        { label: 'Heavy Industries', value: 'Heavy Industries' },
        { label: 'Home Affairs', value: 'Home Affairs' },
        { label: 'Housing & Urban Affairs', value: 'Housing & Urban Affairs' },
        {
          label: 'Information & Broadcasting',
          value: 'Information & Broadcasting',
        },
        { label: 'Jal Shakti', value: 'Jal Shakti' },
        { label: 'Labour & Employment', value: 'Labour & Employment' },
        { label: 'Law & Justice', value: 'Law & Justice' },
        {
          label: 'Micro, Small & Medium Enterprises',
          value: 'Micro, Small & Medium Enterprises',
        },
        { label: 'Mines', value: 'Mines' },
        { label: 'Minority Affairs', value: 'Minority Affairs' },
        { label: 'New & Renewable Energy', value: 'New & Renewable Energy' },
        { label: 'Panchayati Raj', value: 'Panchayati Raj' },
        { label: 'Parliamentary Affairs', value: 'Parliamentary Affairs' },
        {
          label: 'Personnel, Public Grievances & Pensions',
          value: 'Personnel, Public Grievances & Pensions',
        },
        { label: 'Petroleum & Natural Gas', value: 'Petroleum & Natural Gas' },
        { label: 'Planning', value: 'Planning' },
        {
          label: 'Ports, Shipping & Waterways',
          value: 'Ports, Shipping & Waterways',
        },
        { label: 'Power', value: 'Power' },
        { label: "Prime Minister's Office", value: "Prime Minister's Office" },
        { label: 'Rural Development', value: 'Rural Development' },
        {
          label: 'Road Transport & Highways',
          value: 'Road Transport & Highways',
        },
        { label: 'Railways', value: 'Railways' },
        { label: 'Science & Technology', value: 'Science & Technology' },
        {
          label: 'Skill Development & Entrepreneurship',
          value: 'Skill Development & Entrepreneurship',
        },
        {
          label: 'Social Justice & Empowerment',
          value: 'Social Justice & Empowerment',
        },
        {
          label: 'Statistics & Programme Implementation',
          value: 'Statistics & Programme Implementation',
        },
        { label: 'Steel', value: 'Steel' },
        { label: 'Textiles', value: 'Textiles' },
        { label: 'Tourism', value: 'Tourism' },
        { label: 'Tribal Affairs', value: 'Tribal Affairs' },
        {
          label: 'Women & Child Development',
          value: 'Women & Child Development',
        },
        { label: 'Youth Affairs & Sports', value: 'Youth Affairs & Sports' },
        {
          label: 'Other',
          value: 'Other',
        },
      ], // Populate with request type options
    },
    {
      fieldName: 'contactDetails',
      fieldTitle: 'సంప్రదింపు వివరాలు',
      fieldType: 'checkbox', // This seems like a checkbox based on the image
    },
    {
      fieldName: 'detailsKnown',
      fieldTitle: 'తెలిసిన వివరాలు ',
      fieldType: 'checkbox', // This seems like a checkbox based on the image
    },
    {
      fieldName: 'subDepartment',
      fieldTitle: 'ఉపవిభాగం',
      fieldType: 'select',
      options: subDepartmentOptions,
    },
    {
      fieldName: 'requestType',
      fieldTitle: 'అభ్యర్థన రకం*',
      // validationObj: {
      //   required: 'Please Select Request Type',
      // },
      fieldType: 'select',
      options: [
        { label: 'Personal', value: 'personal' },
        { label: 'Community', value: 'community' },
        { label: 'Official', value: 'official' },
        { label: 'Medical', value: 'medical' },
        { label: 'Other', value: 'other' },
      ], // Populate with request type options
    },
    {
      fieldName: 'privateRequestType',
      fieldTitle: 'అభ్యర్థన రకం*',
      // validationObj: {
      //   required: 'Please Select Request Type',
      // },
      fieldType: 'select',
      options: [
        {
          label: 'Employment',
          value: 'Employment',
        },
        {
          label: 'Help/Assistance',
          value: 'Help/Assistance',
        },
        {
          label: 'Other',
          value: 'other',
        },
      ], // Populate with request type options
    },
    {
      fieldName: 'employmentRequestType',
      fieldTitle: 'ఉపాధి అభ్యర్థన రకం*',
      fieldType: 'select',
      options: [
        {
          label: 'New Job',
          value: 'New Job',
        },
        {
          label: 'Role Change',
          value: 'Role Change',
        },
        {
          label: 'Transfer',
          value: 'Transfer',
        },
        {
          label: 'Other',
          value: 'other',
        },
      ],
    },
  ];

  const transferContactDetails = [
    {
      fieldTitle: 'Contact Name',
      fieldName: 'contactName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Contact Number',
      fieldName: 'contactNumber',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Contact Designation',
      fieldName: 'contactDesignation',
      fieldType: 'text',
    },
  ];

  const transferContactDetailsTelugu = [
    {
      fieldTitle: 'సంప్రదింపు పేరు',
      fieldName: 'contactName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'సంప్రదింపు ఫోన్ నంబర్',
      fieldName: 'contactNumber',
      fieldType: 'text',
    },
    {
      fieldTitle: 'సంప్రదింపు హోదా',
      fieldName: 'contactDesignation',
      fieldType: 'text',
    },
  ];

  const communityContactDetails = [
    {
      fieldTitle: 'Cost',
      fieldName: 'cost',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Grant',
      fieldName: 'grant',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Contact Name',
      fieldName: 'contactName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Contact Number',
      fieldName: 'contactNumber',
      fieldType: 'text',
    },
  ];

  const communityContactDetailsTelugu = [
    {
      fieldTitle: 'ఖర్చు',
      fieldName: 'cost',
      fieldType: 'text',
    },
    {
      fieldTitle: 'మంజూరు',
      fieldName: 'grant',
      fieldType: 'text',
    },
    {
      fieldTitle: 'సంప్రదింపు పేరు',
      fieldName: 'contactName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'సంప్రదింపు ఫోన్ నంబర్',
      fieldName: 'contactNumber',
      fieldType: 'text',
    },
  ];

  const officialContactDetails = [
    {
      fieldTitle: 'Contact Name',
      fieldName: 'contactName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Contact Number',
      fieldName: 'contactNumber',
      fieldType: 'text',
    },
  ];

  const officialContactDetailsTelugu = [
    {
      fieldTitle: 'సంప్రదింపు పేరు',
      fieldName: 'contactName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'సంప్రదింపు ఫోన్ నంబర్',
      fieldName: 'contactNumber',
      fieldType: 'text',
    },
  ];

  const medicalDetails = [
    {
      fieldTitle: 'Hospital Name',
      fieldName: 'hospitalName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Type Of Illness',
      fieldName: 'typeOfIllness',
      fieldType: 'text',
    },
    {
      fieldTitle: 'Estimate Amount',
      fieldName: 'estimateAmount',
      fieldType: 'text',
    },
  ];

  const medicalDetailsTelugu = [
    {
      fieldTitle: 'హాస్పిటల్ పేరు',
      fieldName: 'hospitalName',
      fieldType: 'text',
    },
    {
      fieldTitle: 'అనారోగ్యం రకం',
      fieldName: 'typeOfIllness',
      fieldType: 'text',
    },
    {
      fieldTitle: 'అంచనా మొత్తం',
      fieldName: 'estimateAmount',
      fieldType: 'text',
    },
  ];

  const centralPersonalOptions = [
    [
      {
        label: 'Employment Request',
        value: 'Employment Request',
      },
      {
        label: 'Transfer Request',
        value: 'Transfer Request',
      },
      {
        label: 'Other',
        value: 'other',
      },
    ], // Populate with request type options
  ];

  const onPinCodeBlur = (e) => {
    console.log('e', e);
    const { value } = e.target;
    console.log('pincode++++11=+++', value);
    if (value) {
      fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${value}&key=${process.env.REACT_APP_GEOLOCATION_API}`
      )
        .then((response) => response.json())
        .then((res) => {
          if (res?.results && res?.results.length > 0) {
            const data = res.results[0];
            let obj = {};
            get(data, 'address_components').forEach((addr) => {
              if (get(addr, 'types').includes('locality')) {
                obj['city'] = get(addr, 'long_name');
              } else if (
                get(addr, 'types').includes('Administrative_area_level_3')
              ) {
                obj['city'] = get(addr, 'long_name');
              } else if (
                get(addr, 'types').includes('Administrative_area_level_1')
              ) {
                obj['state'] = get(addr, 'short_name');
              } else if (get(addr, 'types').includes('country')) {
                obj['country'] = get(addr, 'short_name');
              }
            });
            let countryVal = '';
            countryVal = obj.country;
            setStates(State.getStatesOfCountry(countryVal));
            let stateObj = obj.state === 'TS' ? 'TG' : obj.state;
            setCities(City.getCitiesOfState(countryVal, stateObj));
            setTimeout(() => {
              setValue('district', obj.city);
              setValue('state', stateObj);
            }, 500);
          }
        });
    }
  };

  return (
    <>
      <div className="block rounded-lg bg-white p-2 lg:pt-6 lg:pb-6 lg:pl-24 lg:pr-24 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] m-4 overflow-auto">
        <div className="flex flex-col lg:flex-row justify-between gap-2 mb-2">
          <BackButton onClick={() => navigate(-1)} />
          <label className="inline-flex items-center cursor-pointer">
            <span className="me-3 text-sm font-medium text-gray-900">
              English
            </span>
            <input
              type="checkbox"
              value=""
              className="sr-only peer"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <div className="relative w-11 h-6 bg-gray-800 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            <span className="ms-3 text-sm font-medium text-gray-900">
              తెలుగు
            </span>
          </label>
          <div className="flex mb-2 text-xl lg:text-2xl font-semibold text-gray-700 justify-end">
            {isEdit ? 'Update' : location?.state?.isView ? 'View' : ' '}{' '}
            Grievance Form - Office of Ram
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          {checked ? (
            <Grid container spacing={1}>
              {requestFieldsTelugu?.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  options,
                } = field;

                return (
                  <>
                    <Grid item xs={12} lg={12} key={fieldName}>
                      <>
                        <label className="block text-gray-800 text-sm font-montsettat font-bold pr-4">
                          {fieldTitle}
                        </label>
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          disabled={
                            fieldName === 'ticketNo'
                              ? true
                              : location?.state?.isView
                          }
                          errors={errors}
                          fieldType={fieldType}
                        />
                      </>
                    </Grid>
                  </>
                );
              })}
            </Grid>
          ) : (
            <Grid container spacing={1}>
              {requestFields?.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  options,
                } = field;

                return (
                  <>
                    <Grid item xs={12} lg={12} key={fieldName}>
                      <>
                        <label className="block text-gray-800 text-sm font-montsettat font-bold pr-4">
                          {fieldTitle}
                        </label>
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          disabled={
                            fieldName === 'ticketNo'
                              ? true
                              : location?.state?.isView
                          }
                          errors={errors}
                          fieldType={fieldType}
                        />
                      </>
                    </Grid>
                  </>
                );
              })}
            </Grid>
          )}

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={ticketToggleAccordion} // Toggle on click
              >
                <h2 className="font-montsettat">
                  {!checked ? 'Request Information' : 'అభ్యర్థన సమాచారం'}
                </h2>
                {/* Render the icon based on the toggle state */}
                {isTicketToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>
            {!checked
              ? isTicketToggle &&
                dataEntryGrievanceTicketFields?.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <>
                      <Grid item xs={12} lg={3} key={fieldName}>
                        {fieldType === 'date' && fieldName === 'issueOpen' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={new Date()}
                              onChange={(e) =>
                                setIssueOpen(
                                  moment(e.target.value).format('mm-dd-yyyy')
                                )
                              }
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={true}
                            />
                          </>
                        ) : fieldType === 'date' &&
                          fieldName === 'targetResolution' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={issueOpen}
                              onChange={(e) =>
                                setTargetResolution(
                                  moment(e.target.value).format('mm-dd-yyyy')
                                )
                              }
                              readOnly
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : (
                          <>
                            <label className="block text-gray-800 text-sm font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <InputField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              register={register}
                              disabled={
                                fieldName === 'ticketNo'
                                  ? true
                                  : location?.state?.isView
                              }
                              errors={errors}
                              fieldType={fieldType}
                            />
                          </>
                        )}
                      </Grid>
                    </>
                  );
                })
              : isTicketToggle &&
                dataEntryGrievanceTicketFieldsTelugu?.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <>
                      <Grid item xs={12} lg={3} key={fieldName}>
                        {fieldType === 'date' && fieldName === 'issueOpen' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={new Date()}
                              onChange={(e) =>
                                setIssueOpen(
                                  moment(e.target.value).format('mm-dd-yyyy')
                                )
                              }
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={true}
                            />
                          </>
                        ) : fieldType === 'date' &&
                          fieldName === 'targetResolution' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={issueOpen}
                              onChange={(e) =>
                                setTargetResolution(
                                  moment(e.target.value).format('mm-dd-yyyy')
                                )
                              }
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : (
                          <>
                            <label className="block text-gray-800 text-sm font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <InputField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              register={register}
                              disabled={
                                fieldName === 'ticketNo'
                                  ? true
                                  : location?.state?.isView
                              }
                              errors={errors}
                              fieldType={fieldType}
                            />
                          </>
                        )}
                      </Grid>
                    </>
                  );
                })}
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={applicantToggleAccordion} // Toggle on click
              >
                <h2 className="font-montsettat">
                  {!checked ? 'Applicant Information' : 'దరఖాస్తుదారు సమాచారం'}
                </h2>
                {/* Render the icon based on the toggle state */}
                {isApplicantToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>
            {!checked
              ? isApplicantToggle &&
                grievanceApplicantFields?.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <Grid item xs={12} lg={3} key={fieldName}>
                      {fieldName === 'state' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName="state"
                            options={states?.map((state) => ({
                              label: state?.name,
                              value: state?.isoCode,
                            }))}
                            register={register}
                            // validationObj={{
                            //   required: 'Please Select State',
                            // }}
                            onChange={(e) => setState(e.target.value)}
                            errors={errors}
                            disabled={location?.state?.isView}
                          />
                        </>
                      ) : fieldName === 'district' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName="district"
                            options={cities?.map((city) => ({
                              label: city?.name,
                              value: city?.name,
                            }))}
                            register={register}
                            onChange={(e) => setDistrict(e.target.value)}
                            // validationObj={{
                            //   required: 'Please Select District',
                            // }}
                            errors={errors}
                            disabled={location?.state?.isView}
                          />
                        </>
                      ) : fieldName === 'constituency' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length > 0 ? (
                            <SelectDropdown
                              fieldName="constituency"
                              options={constituencies?.map(
                                (niyojakavargam) => ({
                                  label: niyojakavargam,
                                  value: niyojakavargam,
                                })
                              )}
                              register={register}
                              onChange={(e) => setConstituency(e.target.value)}
                              // validationObj={{
                              //   required: 'Please Select Mandal',
                              // }}
                              errors={errors}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="constituency"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'mandal' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length > 0 && mandals?.length > 0 ? (
                            <SelectDropdown
                              fieldName="mandal"
                              options={mandals?.map((mandalam) => ({
                                label: mandalam,
                                value: mandalam,
                              }))}
                              register={register}
                              onChange={(e) => setMandal(e.target.value)}
                              // validationObj={{
                              //   required: 'Please Select Mandal',
                              // }}
                              errors={errors}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="mandal"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'village' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length &&
                          mandals.length > 0 &&
                          villages?.length > 0 ? (
                            <SelectDropdown
                              fieldName="village"
                              options={villages?.map((gramam) => ({
                                label: gramam,
                                value: gramam,
                              }))}
                              register={register}
                              // validationObj={{
                              //   required: 'Please Select Village',
                              // }}
                              errors={errors}
                              onChange={(e) => setVillage(e.target.value)}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="village"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'applicantMobile' ? (
                        <>
                          <label className="block text-gray-800 text-sm font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <PhoneInput
                            className="shadow appearance-none border border-solid border-gray-700 w-full py-2.5 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 disabled:bg-gray-200"
                            country="IN"
                            name={fieldName}
                            defaultValue={getValues(fieldName)}
                            control={control}
                            id={fieldName}
                            rules={{
                              validate: (value) =>
                                isPossiblePhoneNumber(`${value}`),
                            }}
                            placeholder="Phone Number"
                          />
                          {errors[fieldName] && (
                            <p className="py-2 text-red-900">
                              Enter Valid Phone Number
                            </p>
                          )}
                        </>
                      ) : (
                        <>
                          <label className="block text-gray-800 text-sm font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            disabled={
                              fieldName === 'ticketNo'
                                ? true
                                : location?.state?.isView
                            }
                            onBlur={fieldName === 'pincode' && onPinCodeBlur}
                            errors={errors}
                            fieldType={fieldType}
                          />
                        </>
                      )}
                    </Grid>
                  );
                })
              : isApplicantToggle &&
                grievanceApplicantFieldsTelugu?.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <Grid item xs={12} lg={3} key={fieldName}>
                      {fieldName === 'state' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName="state"
                            options={states?.map((state) => ({
                              label: state?.name,
                              value: state?.isoCode,
                            }))}
                            register={register}
                            // validationObj={{
                            //   required: 'Please Select State',
                            // }}
                            onChange={(e) => setState(e.target.value)}
                            errors={errors}
                            disabled={location?.state?.isView}
                          />
                        </>
                      ) : fieldName === 'district' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName="district"
                            options={cities?.map((city) => ({
                              label: city?.name,
                              value: city?.name,
                            }))}
                            register={register}
                            onChange={(e) => setDistrict(e.target.value)}
                            // validationObj={{
                            //   required: 'Please Select District',
                            // }}
                            errors={errors}
                            disabled={location?.state?.isView}
                          />
                        </>
                      ) : fieldName === 'constituency' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length > 0 ? (
                            <SelectDropdown
                              fieldName="constituency"
                              options={constituencies?.map(
                                (niyojakavargam) => ({
                                  label: niyojakavargam,
                                  value: niyojakavargam,
                                })
                              )}
                              register={register}
                              onChange={(e) => setConstituency(e.target.value)}
                              // validationObj={{
                              //   required: 'Please Select Mandal',
                              // }}
                              errors={errors}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="constituency"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'mandal' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length && mandals?.length > 0 ? (
                            <SelectDropdown
                              fieldName="mandal"
                              options={mandals?.map((mandalam) => ({
                                label: mandalam,
                                value: mandalam,
                              }))}
                              register={register}
                              onChange={(e) => setMandal(e.target.value)}
                              // validationObj={{
                              //   required: 'Please Select Mandal',
                              // }}
                              errors={errors}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="mandal"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'village' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          {constituencies?.length &&
                          mandals.length > 0 &&
                          villages?.length > 0 ? (
                            <SelectDropdown
                              fieldName="village"
                              options={villages?.map((gramam) => ({
                                label: gramam,
                                value: gramam,
                              }))}
                              register={register}
                              // validationObj={{
                              //   required: 'Please Select Village',
                              // }}
                              errors={errors}
                              disabled={location?.state?.isView}
                            />
                          ) : (
                            <InputField
                              fieldName="village"
                              validationObj={validationObj}
                              register={register}
                              disabled={location?.state?.isView}
                              errors={errors}
                              fieldType="text"
                            />
                          )}
                        </>
                      ) : fieldName === 'applicantMobile' ? (
                        <>
                          <label className="block text-gray-800 text-sm font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <PhoneInput
                            className="shadow appearance-none border border-solid border-gray-700 w-full py-2.5 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 disabled:bg-gray-200"
                            country="IN"
                            name={fieldName}
                            defaultValue={getValues(fieldName)}
                            control={control}
                            id={fieldName}
                            rules={{
                              validate: (value) =>
                                isPossiblePhoneNumber(`${value}`),
                            }}
                            placeholder="Phone Number"
                          />
                          {errors[fieldName] && (
                            <p className="py-2 text-red-900">
                              Enter Valid Phone Number
                            </p>
                          )}
                        </>
                      ) : (
                        <>
                          <label className="block text-gray-800 text-sm font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            disabled={
                              fieldName === 'ticketNo'
                                ? true
                                : location?.state?.isView
                            }
                            onBlur={fieldName === 'pincode' && onPinCodeBlur}
                            errors={errors}
                            fieldType={fieldType}
                          />
                        </>
                      )}
                    </Grid>
                  );
                })}
            {checked && isApplicantToggle && village === 'other' ? (
              <Grid item xs={12} lg={3}>
                <label className="block text-sm text-gray-800 font-bold pr-4">
                  ఇతరాలు
                </label>
                <InputField
                  fieldName="applicantMiscellaneous"
                  register={register}
                  disabled={location?.state?.isView}
                  errors={errors}
                  fieldType="text"
                />
              </Grid>
            ) : !checked && isApplicantToggle && village === 'other' ? (
              <Grid item xs={12} lg={3}>
                <label className="block text-sm text-gray-800 font-bold pr-4">
                  Miscellaneous
                </label>
                <InputField
                  fieldName="applicantMiscellaneous"
                  register={register}
                  disabled={location?.state?.isView}
                  errors={errors}
                  fieldType="text"
                />
              </Grid>
            ) : null}
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={requestToggleAccordion} // Toggle on click
              >
                <h2 className="font-montsettat">
                  {!checked ? 'Request Details' : 'అభ్యర్థన వివరాలు'}
                </h2>
                {/* Render the icon based on the toggle state */}
                {isRequestToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>

            <>
              {!checked
                ? isRequestToggle &&
                  grievanceRequestFields
                    .filter((field) => field.fieldName === 'requestDescription')
                    .map((field) => {
                      const {
                        fieldTitle,
                        fieldName,
                        fieldType,
                        validationObj,
                      } = field;

                      return (
                        <Grid item xs={12} key={fieldName}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            val={getValues(fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>
                      );
                    })
                : isRequestToggle &&
                  grievanceRequestFieldsTelugu
                    .filter((field) => field.fieldName === 'requestDescription')
                    .map((field) => {
                      const {
                        fieldTitle,
                        fieldName,
                        fieldType,
                        validationObj,
                      } = field;

                      return (
                        <Grid item xs={12} key={fieldName}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            val={getValues(fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>
                      );
                    })}
            </>

            {!checked
              ? isRequestToggle &&
                grievanceRequestFields
                  .filter(
                    (field) =>
                      field.fieldName !== 'additionalInformation' &&
                      field.fieldName !== 'requestDescription'
                  )
                  .map((field) => {
                    const {
                      fieldTitle,
                      fieldName,
                      fieldType,
                      validationObj,
                      options,
                    } = field;

                    return (
                      <Grid item xs={12} lg={3} key={fieldName}>
                        {fieldType === 'date' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={new Date()}
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : fieldType === 'editor' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <CkEditorComponent
                              register={register}
                              fieldName={fieldName}
                              control={control}
                              data={getValues(fieldName) || ''}
                              setValue={setValue}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : fieldType === 'select' ? (
                          fieldName === 'requestMode' ? (
                            <>
                              <label className="block text-sm text-gray-800 font-bold pr-4">
                                {fieldTitle}
                              </label>
                              <SelectDropdown
                                fieldName={fieldName}
                                options={options}
                                register={register}
                                // validationObj={{
                                //   required: 'Please Select Request Node',
                                // }}
                                onChange={(e) => setRequestMode(e.target.value)}
                                errors={errors}
                                val={getValues(fieldName)}
                                disabled={location?.state?.isView}
                              />
                            </>
                          ) : null
                        ) : (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <InputField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              register={register}
                              disabled={
                                fieldName === 'ticketNo'
                                  ? true
                                  : location?.state?.isView
                              }
                              errors={errors}
                              fieldType={fieldType}
                            />
                          </>
                        )}
                      </Grid>
                    );
                  })
              : isRequestToggle &&
                grievanceRequestFieldsTelugu
                  .filter(
                    (field) =>
                      field.fieldName !== 'additionalInformation' &&
                      field.fieldName !== 'requestDescription'
                  )
                  .map((field) => {
                    const {
                      fieldTitle,
                      fieldName,
                      fieldType,
                      validationObj,
                      options,
                    } = field;

                    return (
                      <Grid item xs={12} lg={3} key={fieldName}>
                        {fieldType === 'date' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <DateField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              control={control}
                              Controller={Controller}
                              minDate={new Date()}
                              errors={errors}
                              defaultValue={getValues(fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : fieldType === 'editor' ? (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <CkEditorComponent
                              register={register}
                              fieldName={fieldName}
                              control={control}
                              data={getValues(fieldName) || ''}
                              setValue={setValue}
                              disabled={location?.state?.isView}
                            />
                          </>
                        ) : fieldType === 'select' ? (
                          fieldName === 'requestMode' ? (
                            <>
                              <label className="block text-sm text-gray-800 font-bold pr-4">
                                {fieldTitle}
                              </label>
                              <SelectDropdown
                                fieldName={fieldName}
                                options={options}
                                register={register}
                                // validationObj={{
                                //   required: 'Please Select Request Node',
                                // }}
                                onChange={(e) => setRequestMode(e.target.value)}
                                errors={errors}
                                val={getValues(fieldName)}
                                disabled={location?.state?.isView}
                              />
                            </>
                          ) : null
                        ) : (
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {fieldTitle}
                            </label>
                            <InputField
                              fieldName={fieldName}
                              validationObj={validationObj}
                              register={register}
                              disabled={
                                fieldName === 'ticketNo'
                                  ? true
                                  : location?.state?.isView
                              }
                              errors={errors}
                              fieldType={fieldType}
                            />
                          </>
                        )}
                      </Grid>
                    );
                  })}
            {isRequestToggle && (
              <>
                <>
                  <Grid item xs={12} lg={3}>
                    <label className="block text-sm text-gray-800 font-bold pr-4">
                      {checked
                        ? conditionalFieldsTelugu[13].fieldTitle
                        : conditionalFields[13].fieldTitle}
                    </label>
                    <SelectDropdown
                      fieldName={
                        requestMode === 'private'
                          ? conditionalFields[14].fieldName
                          : conditionalFields[13].fieldName
                      }
                      options={
                        requestMode === 'private'
                          ? conditionalFields[14]?.options
                          : conditionalFields[13].options
                      }
                      register={register}
                      // validationObj={{
                      //   required: 'Please Select Request Type',
                      // }}
                      errors={errors}
                      onChange={(e) => {
                        if (requestMode === 'private') {
                          setPrivateRequestType(e.target.value);
                          setRequestType('');
                        } else {
                          setRequestType(e.target.value);
                          setPrivateRequestType('');
                        }
                      }}
                      val={
                        requestMode === 'private'
                          ? getValues(conditionalFields[14].fieldName)
                          : getValues(conditionalFields[13].fieldName)
                      }
                      disabled={location?.state?.isView}
                    />
                  </Grid>
                  {privateRequestType === 'Employment' && (
                    <Grid item xs={12} lg={3}>
                      <label className="block text-sm text-gray-800 font-bold pr-4">
                        {checked
                          ? conditionalFieldsTelugu[15].fieldTitle
                          : conditionalFields[15].fieldTitle}
                      </label>
                      <SelectDropdown
                        fieldName={conditionalFields[15].fieldName}
                        options={conditionalFields[15].options}
                        register={register}
                        // validationObj={{
                        //   required: 'Please Select Request Type',
                        // }}
                        onChange={(e) => {
                          setEmploymentRequestType(e.target.value);
                        }}
                        errors={errors}
                        val={getValues(conditionalFields[15].fieldName)}
                        disabled={location?.state?.isView}
                      />
                    </Grid>
                  )}

                  {requestMode === 'state' && requestType === 'personal' && (
                    <Grid item xs={12} lg={3}>
                      <label className="block text-sm text-gray-800 font-bold pr-4">
                        {checked
                          ? conditionalFieldsTelugu[0].fieldTitle
                          : conditionalFields[0].fieldTitle}
                      </label>
                      <SelectDropdown
                        fieldName={conditionalFields[0].fieldName}
                        options={conditionalFields[0]?.options}
                        register={register}
                        // validationObj={{
                        //   required: 'Please Select Request Type',
                        // }}
                        errors={errors}
                        onChange={(e) => setPersonalRequestType(e.target.value)}
                        val={getValues(conditionalFields[0].fieldName)}
                        disabled={location?.state?.isView}
                      />
                    </Grid>
                  )}
                  {requestMode === 'central' && requestType === 'personal' && (
                    <Grid item xs={12} lg={3}>
                      <label className="block text-sm text-gray-800 font-bold pr-4">
                        {checked
                          ? conditionalFieldsTelugu[0].fieldTitle
                          : conditionalFields[0].fieldTitle}
                      </label>
                      <SelectDropdown
                        fieldName={conditionalFields[0].fieldName}
                        options={centralPersonalOptions}
                        register={register}
                        // validationObj={{
                        //   required: 'Please Select Request Type',
                        // }}
                        errors={errors}
                        onChange={(e) => setPersonalRequestType(e.target.value)}
                        val={getValues(conditionalFields[0].fieldName)}
                        disabled={location?.state?.isView}
                      />
                    </Grid>
                  )}
                  {requestType === 'personal' &&
                    personalRequestType === 'TTD Darshan' && (
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {checked
                              ? conditionalFieldsTelugu[3].fieldTitle
                              : conditionalFields[3].fieldTitle}
                          </label>
                          <DateField
                            fieldName={conditionalFields[3].fieldName}
                            validationObj={conditionalFields[3].validationObj}
                            control={control}
                            Controller={Controller}
                            minDate={new Date()}
                            disabled={location?.state?.isView}
                            onChange={(e) =>
                              setTtdAvailableSlot(
                                moment(e.target.value).format('YYYY-MM-DD')
                              )
                            }
                            readOnly
                            excluded={ttdDatesApproved}
                            highlighted={ttdDatesInProgress}
                            errors={errors}
                            defaultValue={getValues(
                              conditionalFields[3].fieldName
                            )}
                          />
                        </>
                      </Grid>
                    )}
                  {privateRequestType === 'Help/Assistance' && (
                    <Grid item xs={12} lg={3}>
                      <>
                        <label className="block text-sm text-gray-800 font-bold pr-4">
                          {checked
                            ? conditionalFieldsTelugu[4].fieldTitle
                            : conditionalFields[4].fieldTitle}
                        </label>
                        <InputField
                          fieldName={conditionalFields[4].fieldName}
                          validationObj={conditionalFields[4].validationObj}
                          register={register}
                          errors={errors}
                          fieldType={conditionalFields[4].fieldType}
                          onChange={(e) => setOther(e.target.value)}
                          val={getValues(conditionalFields[4].fieldName)}
                          disabled={location?.state?.isView}
                        />
                      </>
                    </Grid>
                  )}
                  {privateRequestType === 'other' && (
                    <Grid item xs={12} lg={3}>
                      <>
                        <label className="block text-sm text-gray-800 font-bold pr-4">
                          {checked
                            ? conditionalFieldsTelugu[4].fieldTitle
                            : conditionalFields[4].fieldTitle}
                        </label>
                        <InputField
                          fieldName={conditionalFields[4].fieldName}
                          validationObj={conditionalFields[4].validationObj}
                          register={register}
                          errors={errors}
                          fieldType={conditionalFields[4].fieldType}
                          onChange={(e) => setOther(e.target.value)}
                          val={getValues(conditionalFields[4].fieldName)}
                          disabled={location?.state?.isView}
                        />
                      </>
                    </Grid>
                  )}
                  {privateRequestType === 'Employment' &&
                    employmentRequestType === 'other' && (
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {checked
                              ? conditionalFieldsTelugu[4].fieldTitle
                              : conditionalFields[4].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[4].fieldName}
                            validationObj={conditionalFields[4].validationObj}
                            register={register}
                            errors={errors}
                            fieldType={conditionalFields[4].fieldType}
                            onChange={(e) => setOther(e.target.value)}
                            val={getValues(conditionalFields[4].fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </>
                      </Grid>
                    )}
                  {requestType === 'personal' &&
                    personalRequestType === 'other' && (
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {checked
                              ? conditionalFieldsTelugu[4].fieldTitle
                              : conditionalFields[4].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[4].fieldName}
                            validationObj={conditionalFields[4].validationObj}
                            register={register}
                            errors={errors}
                            fieldType={conditionalFields[4].fieldType}
                            onChange={(e) => setOther(e.target.value)}
                            val={getValues(conditionalFields[4].fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </>
                      </Grid>
                    )}
                  {requestType === 'personal' &&
                    personalRequestType === 'Employment Request' && (
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {checked
                              ? conditionalFieldsTelugu[5].fieldTitle
                              : conditionalFields[5].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[5].fieldName}
                            validationObj={conditionalFields[5].validationObj}
                            register={register}
                            errors={errors}
                            fieldType={conditionalFields[5].fieldType}
                            onChange={(e) => setQualification(e.target.value)}
                            val={getValues(conditionalFields[5].fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </>
                      </Grid>
                    )}
                  {requestType === 'personal' &&
                    personalRequestType === 'Transfer Request' && (
                      <>
                        <Grid item xs={12} lg={3}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {checked
                              ? conditionalFieldsTelugu[1].fieldTitle
                              : conditionalFields[1].fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName={
                              requestMode === 'state'
                                ? conditionalFields[1].fieldName
                                : conditionalFields[9].fieldName
                            }
                            options={
                              requestMode === 'state'
                                ? conditionalFields[1]?.options
                                : conditionalFields[9].options
                            }
                            register={register}
                            // validationObj={{
                            //   required: 'Please Select Request Type',
                            // }}
                            errors={errors}
                            onChange={(e) => {
                              if (requestMode === 'state') {
                                setStateDepartment(e.target.value);
                                setCentralDepartment('');
                              } else {
                                setCentralDepartment(e.target.value);
                                setStateDepartment('');
                              }
                            }}
                            val={
                              requestMode === 'state'
                                ? getValues(conditionalFields[1].fieldName)
                                : getValues(conditionalFields[9].fieldName)
                            }
                            disabled={location?.state?.isView}
                          />
                        </Grid>
                        {requestMode === 'state' && (
                          <Grid item xs={12} lg={3}>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {checked
                                ? conditionalFieldsTelugu[12].fieldTitle
                                : conditionalFields[12].fieldTitle}
                            </label>
                            <SelectDropdown
                              fieldName={conditionalFields[12].fieldName}
                              options={conditionalFields[12].options}
                              register={register}
                              // validationObj={{
                              //   required: 'Please Select Request Type',
                              // }}
                              errors={errors}
                              val={getValues(conditionalFields[12].fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </Grid>
                        )}

                        <Grid item xs={12} lg={3}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {checked
                              ? conditionalFieldsTelugu[7].fieldTitle
                              : conditionalFields[7].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[7].fieldName}
                            validationObj={conditionalFields[7].validationObj}
                            register={register}
                            errors={errors}
                            fieldType={conditionalFields[7].fieldType}
                            onChange={(e) => setCurrentLocation(e.target.value)}
                            val={getValues(conditionalFields[7].fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>

                        <Grid item xs={12} lg={3}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {checked
                              ? conditionalFieldsTelugu[8].fieldTitle
                              : conditionalFields[8].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[8].fieldName}
                            validationObj={conditionalFields[8].validationObj}
                            register={register}
                            errors={errors}
                            fieldType={conditionalFields[8].fieldType}
                            onChange={(e) =>
                              setRequestedLocation(e.target.value)
                            }
                            val={getValues(conditionalFields[8].fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>

                        <Grid item xs={12} lg={3}>
                          <div className="flex items-center lg:mt-10">
                            <CheckboxField
                              fieldName={conditionalFields[10].fieldName}
                              register={register}
                              validationObj={
                                conditionalFields[10].validationObj
                              }
                              onChange={(checked) => setContactDetails(checked)}
                              errors={errors}
                              disabled={location?.state?.isView}
                            />
                            <label className="block text-sm text-gray-800 font-bold pl-2">
                              {checked
                                ? conditionalFieldsTelugu[10].fieldTitle
                                : conditionalFields[10].fieldTitle}
                            </label>
                          </div>
                        </Grid>

                        {!checked
                          ? contactDetails &&
                            transferContactDetails.map((details, index) => (
                              <Grid item xs={12} lg={3} key={index}>
                                <label className="block text-sm text-gray-800 font-bold pr-4">
                                  {details.fieldTitle}
                                </label>
                                <InputField
                                  fieldName={details.fieldName}
                                  validationObj={{ required: false }}
                                  register={register}
                                  errors={errors}
                                  val={getValues(details.fieldName)}
                                  disabled={location?.state?.isView}
                                />
                              </Grid>
                            ))
                          : contactDetails &&
                            transferContactDetailsTelugu.map(
                              (details, index) => (
                                <Grid item xs={12} lg={3} key={index}>
                                  <label className="block text-sm text-gray-800 font-bold pr-4">
                                    {details.fieldTitle}
                                  </label>
                                  <InputField
                                    fieldName={details.fieldName}
                                    validationObj={{ required: false }}
                                    register={register}
                                    errors={errors}
                                    val={getValues(details.fieldName)}
                                    disabled={location?.state?.isView}
                                  />
                                </Grid>
                              )
                            )}
                      </>
                    )}
                </>
                <>
                  {requestMode !== 'private' && requestType === 'official' && (
                    <>
                      <Grid item xs={12} lg={3}>
                        <label className="block text-gray-800 text-sm font-bold pr-4">
                          {checked
                            ? conditionalFieldsTelugu[1].fieldTitle
                            : conditionalFields[1].fieldTitle}
                        </label>
                        <SelectDropdown
                          fieldName={
                            requestMode === 'state'
                              ? conditionalFields[1].fieldName
                              : conditionalFields[9].fieldName
                          }
                          options={
                            requestMode === 'state'
                              ? conditionalFields[1]?.options
                              : conditionalFields[9].options
                          }
                          register={register}
                          // validationObj={{
                          //   required: 'Please Select Request Type',
                          // }}
                          errors={errors}
                          onChange={(e) => {
                            if (requestMode === 'state') {
                              setStateDepartment(e.target.value);
                              setCentralDepartment('');
                            } else {
                              setCentralDepartment(e.target.value);
                              setStateDepartment('');
                            }
                          }}
                          val={
                            requestMode === 'state'
                              ? getValues(conditionalFields[1].fieldName)
                              : getValues(conditionalFields[9].fieldName)
                          }
                          disabled={location?.state?.isView}
                        />
                      </Grid>
                      {requestMode === 'state' && (
                        <Grid item xs={12} lg={3}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {checked
                              ? conditionalFieldsTelugu[12].fieldTitle
                              : conditionalFields[12].fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName={conditionalFields[12].fieldName}
                            options={conditionalFields[12].options}
                            register={register}
                            // validationObj={{
                            //   required: 'Please Select Request Type',
                            // }}
                            errors={errors}
                            val={getValues(conditionalFields[12].fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>
                      )}
                    </>
                  )}

                  {!checked
                    ? requestType === 'official' &&
                      officialContactDetails.map((details) => (
                        <Grid item xs={12} lg={3}>
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {details.fieldTitle}
                            </label>
                            <InputField
                              fieldName={details.fieldName}
                              validationObj={details.validationObj}
                              register={register}
                              errors={errors}
                              fieldType={details.fieldType}
                              val={getValues(details.fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        </Grid>
                      ))
                    : requestType === 'official' &&
                      officialContactDetailsTelugu.map((details) => (
                        <Grid item xs={12} lg={3}>
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {details.fieldTitle}
                            </label>
                            <InputField
                              fieldName={details.fieldName}
                              validationObj={details.validationObj}
                              register={register}
                              errors={errors}
                              fieldType={details.fieldType}
                              val={getValues(details.fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        </Grid>
                      ))}
                </>
                <>
                  {requestMode !== 'private' && requestType === 'community' && (
                    <>
                      <Grid item xs={12} lg={3}>
                        <label className="block text-sm text-gray-800 font-bold pr-4">
                          {checked
                            ? conditionalFieldsTelugu[1].fieldTitle
                            : conditionalFields[1].fieldTitle}
                        </label>
                        <SelectDropdown
                          fieldName={
                            requestMode === 'state'
                              ? conditionalFields[1].fieldName
                              : conditionalFields[9].fieldName
                          }
                          options={
                            requestMode === 'state'
                              ? conditionalFields[1]?.options
                              : conditionalFields[9].options
                          }
                          register={register}
                          // validationObj={{
                          //   required: 'Please Select Request Type',
                          // }}
                          errors={errors}
                          onChange={(e) => {
                            if (requestMode === 'state') {
                              setStateDepartment(e.target.value);
                              setCentralDepartment('');
                            } else {
                              setCentralDepartment(e.target.value);
                              setStateDepartment('');
                            }
                          }}
                          val={
                            requestMode === 'state'
                              ? getValues(conditionalFields[1].fieldName)
                              : getValues(conditionalFields[9].fieldName)
                          }
                          disabled={location?.state?.isView}
                        />
                      </Grid>
                      {requestMode === 'state' && (
                        <Grid item xs={12} lg={3}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {checked
                              ? conditionalFieldsTelugu[12].fieldTitle
                              : conditionalFields[12].fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName={conditionalFields[12].fieldName}
                            options={conditionalFields[12].options}
                            register={register}
                            // validationObj={{
                            //   required: 'Please Select Request Type',
                            // }}
                            errors={errors}
                            val={getValues(conditionalFields[12].fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} lg={3}>
                        <div className="flex items-center lg:mt-10">
                          <CheckboxField
                            fieldName={conditionalFields[11].fieldName}
                            register={register}
                            validationObj={conditionalFields[11].validationObj}
                            onChange={(checked) => setDetailsKnown(checked)}
                            errors={errors}
                            disabled={location?.state?.isView}
                          />
                          <label className="block text-gray-800 text-sm font-bold pl-2">
                            {checked
                              ? conditionalFieldsTelugu[11].fieldTitle
                              : conditionalFields[11].fieldTitle}
                          </label>
                        </div>
                      </Grid>
                    </>
                  )}

                  {!checked
                    ? requestType === 'community' &&
                      detailsKnown &&
                      communityContactDetails.map((details) => (
                        <Grid item xs={12} lg={3}>
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {details.fieldTitle}
                            </label>
                            <InputField
                              fieldName={details.fieldName}
                              validationObj={details.validationObj}
                              register={register}
                              errors={errors}
                              fieldType={details.fieldType}
                              val={getValues(details.fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        </Grid>
                      ))
                    : requestType === 'community' &&
                      detailsKnown &&
                      communityContactDetailsTelugu.map((details) => (
                        <Grid item xs={12} lg={3}>
                          <>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {details.fieldTitle}
                            </label>
                            <InputField
                              fieldName={details.fieldName}
                              validationObj={details.validationObj}
                              register={register}
                              errors={errors}
                              fieldType={details.fieldType}
                              val={getValues(details.fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </>
                        </Grid>
                      ))}
                </>
                <>
                  {checked
                    ? requestType === 'medical' && (
                        <>
                          <Grid item xs={12} lg={3}>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {checked
                                ? conditionalFieldsTelugu[2].fieldTitle
                                : conditionalFields[2].fieldTitle}
                            </label>
                            <SelectDropdown
                              fieldName={conditionalFields[2].fieldName}
                              options={conditionalFields[2]?.options}
                              register={register}
                              // validationObj={{
                              //   required: 'Please Select Request Type',
                              // }}
                              errors={errors}
                              onChange={(e) => {
                                setMedicalRequestType(e.target.value);
                                setPersonalRequestType('');
                              }}
                              val={getValues(conditionalFields[2].fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </Grid>
                          {medicalDetailsTelugu.map((details) => (
                            <Grid item xs={12} lg={3}>
                              <>
                                <label className="block text-sm text-gray-800 font-bold pr-4">
                                  {details.fieldTitle}
                                </label>
                                <InputField
                                  fieldName={details.fieldName}
                                  validationObj={details.validationObj}
                                  register={register}
                                  errors={errors}
                                  fieldType={details.fieldType}
                                  val={getValues(details.fieldName)}
                                  disabled={location?.state?.isView}
                                />
                              </>
                            </Grid>
                          ))}
                        </>
                      )
                    : requestType === 'medical' && (
                        <>
                          <Grid item xs={12} lg={3}>
                            <label className="block text-sm text-gray-800 font-bold pr-4">
                              {conditionalFields[2].fieldTitle}
                            </label>
                            <SelectDropdown
                              fieldName={conditionalFields[2].fieldName}
                              options={conditionalFields[2]?.options}
                              register={register}
                              // validationObj={{
                              //   required: 'Please Select Request Type',
                              // }}
                              errors={errors}
                              onChange={(e) => {
                                setMedicalRequestType(e.target.value);
                                setPersonalRequestType('');
                              }}
                              val={getValues(conditionalFields[2].fieldName)}
                              disabled={location?.state?.isView}
                            />
                          </Grid>
                          {medicalDetails.map((details) => (
                            <Grid item xs={12} lg={3}>
                              <>
                                <label className="block text-sm text-gray-800 font-bold pr-4">
                                  {details.fieldTitle}
                                </label>
                                <InputField
                                  fieldName={details.fieldName}
                                  validationObj={details.validationObj}
                                  register={register}
                                  errors={errors}
                                  fieldType={details.fieldType}
                                  val={getValues(details.fieldName)}
                                  disabled={location?.state?.isView}
                                />
                              </>
                            </Grid>
                          ))}
                        </>
                      )}
                </>
                <>
                  {requestType === 'other' && (
                    <>
                      <Grid item xs={12} lg={3}>
                        <>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {checked
                              ? conditionalFieldsTelugu[4].fieldTitle
                              : conditionalFields[4].fieldTitle}
                          </label>
                          <InputField
                            fieldName={conditionalFields[4].fieldName}
                            validationObj={conditionalFields[4].validationObj}
                            register={register}
                            errors={errors}
                            onChange={(e) => setOther(e.target.value)}
                            fieldType={conditionalFields[4].fieldType}
                            val={getValues(conditionalFields[4].fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </>
                      </Grid>
                    </>
                  )}
                </>
              </>
            )}

            <>
              {!checked
                ? isRequestToggle &&
                  grievanceRequestFields
                    .filter(
                      (field) => field.fieldName === 'additionalInformation'
                    )
                    .map((field) => {
                      const {
                        fieldTitle,
                        fieldName,
                        fieldType,
                        validationObj,
                      } = field;

                      return (
                        <Grid item xs={12} key={fieldName}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            val={getValues(fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>
                      );
                    })
                : isRequestToggle &&
                  grievanceRequestFieldsTelugu
                    .filter(
                      (field) => field.fieldName === 'additionalInformation'
                    )
                    .map((field) => {
                      const {
                        fieldTitle,
                        fieldName,
                        fieldType,
                        validationObj,
                      } = field;

                      return (
                        <Grid item xs={12} key={fieldName}>
                          <label className="block text-sm text-gray-800 font-bold pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            val={getValues(fieldName)}
                            disabled={location?.state?.isView}
                          />
                        </Grid>
                      );
                    })}
            </>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={refferalToggleAccordion} // Toggle on click
              >
                <h2 className="font-montsettat">
                  {!checked ? 'Referral Details' : 'రెఫరల్ వివరాలు'}
                </h2>
                {/* Render the icon based on the toggle state */}
                {isRefferalToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>

            {!checked
              ? isRefferalToggle &&
                referalFields.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <Grid item xs={12} key={fieldName} lg={2.4}>
                      <label className="block text-sm text-gray-800 font-bold pr-4">
                        {fieldTitle}
                      </label>

                      {fieldType === 'select' ? (
                        <SelectDropdown
                          fieldName={fieldName}
                          register={register}
                          options={
                            fieldName === 'referralType'
                              ? referralType
                              : referralMode
                          }
                          onChange={(e) =>
                            fieldName === 'referralType' &&
                            setRefType(e.target.value)
                          }
                          validationObj={validationObj}
                          errors={errors}
                          disabled={location?.state?.isView}
                          val={getValues(
                            fieldName === 'referralType'
                              ? 'referralType'
                              : 'referralMode'
                          )}
                        />
                      ) : fieldName === 'referralContact' ? (
                        <>
                          {/* <label className="block text-gray-800 text-sm font-bold mb-3 pr-4">
                          {fieldTitle}
                        </label> */}
                          <PhoneInput
                            className="shadow appearance-none border border-solid border-gray-700 w-full py-2.5 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 disabled:bg-gray-200"
                            country="IN"
                            name={fieldName}
                            defaultValue={getValues(fieldName)}
                            control={control}
                            placeholder="Phone Number"
                            id={fieldName}
                            onBlur={handleBlur}
                            rules={{
                              validate: (value) =>
                                isPossiblePhoneNumber(`${value}`),
                            }}
                          />
                          {errors[fieldName] && (
                            <p className="py-2 text-red-900">
                              Enter Valid Phone Number
                            </p>
                          )}
                        </>
                      ) : (
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          errors={errors}
                          fieldType={fieldType}
                          disabled={location?.state?.isView}
                          value={getValues(fieldName)}
                        />
                      )}
                    </Grid>
                  );
                })
              : isRefferalToggle &&
                referalFieldsTelugu.map((field) => {
                  const {
                    fieldTitle,
                    fieldName,
                    fieldType,
                    validationObj,
                    options,
                  } = field;

                  return (
                    <Grid item xs={12} key={fieldName} lg={2.4}>
                      <label className="block text-sm text-gray-800 font-bold pr-4">
                        {fieldTitle}
                      </label>

                      {fieldType === 'select' ? (
                        <SelectDropdown
                          fieldName={fieldName}
                          register={register}
                          options={
                            fieldName === 'referralType'
                              ? referralType
                              : referralMode
                          }
                          onChange={(e) =>
                            fieldName === 'referralType' &&
                            setRefType(e.target.value)
                          }
                          validationObj={validationObj}
                          errors={errors}
                          disabled={location?.state?.isView}
                          val={getValues(
                            fieldName === 'referralType'
                              ? 'referralType'
                              : 'referralMode'
                          )}
                        />
                      ) : fieldName === 'referralContact' ? (
                        <>
                          {/* <label className="block text-gray-800 text-sm font-bold mb-3 pr-4">
                          {fieldTitle}
                        </label> */}
                          <PhoneInput
                            className="shadow appearance-none border border-solid border-gray-700 w-full py-2.5 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500 disabled:bg-gray-200"
                            country="IN"
                            name={fieldName}
                            defaultValue={getValues(fieldName)}
                            control={control}
                            placeholder="Phone Number"
                            id={fieldName}
                            onBlur={handleBlur}
                            rules={{
                              validate: (value) =>
                                isPossiblePhoneNumber(`${value}`),
                            }}
                          />
                          {errors[fieldName] && (
                            <p className="py-2 text-red-900">
                              Enter Valid Phone Number
                            </p>
                          )}
                        </>
                      ) : (
                        <InputField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          register={register}
                          errors={errors}
                          fieldType={fieldType}
                          disabled={location?.state?.isView}
                          value={getValues(fieldName)}
                        />
                      )}
                    </Grid>
                  );
                })}
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={assignedToggleAccordion} // Toggle on click
              >
                <h2>For Office Use Only</h2>
                {/* Render the icon based on the toggle state */}
                {isAssignedToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>
            {isAssignedToggle &&
              approvalActionFields.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  options,
                } = field;

                return (
                  <Grid item xs={12} key={fieldName} lg={3}>
                    <label className="block text-sm text-gray-800 font-bold pr-4">
                      {fieldTitle}
                    </label>

                    {fieldType === 'select' && fieldName === 'priority' ? (
                      <SelectDropdown
                        fieldName={fieldName}
                        register={register}
                        options={priority}
                        validationObj={validationObj}
                        fieldType={fieldType}
                        errors={errors}
                        disabled={location?.state?.isView}
                      />
                    ) : fieldType === 'date' &&
                      fieldName === 'targetResolution' ? (
                      <>
                        <DateField
                          fieldName={fieldName}
                          validationObj={validationObj}
                          control={control}
                          Controller={Controller}
                          errors={errors}
                          defaultValue={getValues(fieldName)}
                          disabled={location?.state?.isView}
                        />
                      </>
                    ) : fieldType === 'text' && fieldName === 'ccEmail' ? (
                      <>
                        <InputField
                          fieldName={fieldName}
                          validationObj={emailValidation}
                          register={register}
                          errors={errors}
                          fieldType={fieldType}
                          disabled={location?.state?.isView}
                          value={getValues(fieldName)}
                        />
                      </>
                    ) : (
                      <SelectDropdown
                        fieldType={fieldType}
                        fieldName={fieldName}
                        register={register}
                        options={assignedTo}
                        validationObj={validationObj}
                        errors={errors}
                        disabled={location?.state?.isView}
                      />
                    )}
                  </Grid>
                );
              })}
          </Grid>

          <TicketCharter
            role={role}
            taskId={id}
            ticketNo={ticketNo}
            isView={location?.state?.isView}
            noteStatus="backlog"
            loc={window.location.pathname}
          />

          <hr />
          <div className="flex flex-col lg:flex-row items-center justify-center space-x-4">
            <Grid item>
              <Button
                variant="contained"
                color="error"
                onClick={onCancel}
                className="mt-5"
              >
                {location?.state?.isView ? 'Back' : 'Cancel'}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                value="save"
                disabled={location?.state?.isView}
                onClick={handleSubmit(onSubmit)}
                className="mt-5"
              >
                {isEdit ? 'Update' : 'Save'}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                // color="primary"
                type="submit"
                className="mt-5 bg-blueBg hover:blueBg"
                disabled={location?.state?.isView}
                value="submit"
                onClick={handleSubmit(onSubmit)}
              >
                Submit
              </Button>
            </Grid>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddGms;
